(()=>{'use strict';
const $=(q,scope=document)=>scope.querySelector(q), $$=(q,scope=document)=>[...scope.querySelectorAll(q)];
const menu=$('[data-menu-toggle]'),nav=$('#site-nav');if(menu&&nav)menu.addEventListener('click',()=>{const on=nav.classList.toggle('is-open');menu.setAttribute('aria-expanded',String(on))});
$$('[data-submenu-toggle]').forEach(button=>button.addEventListener('click',()=>{const panel=$('.mega-menu',button.parentElement),on=panel.hidden;$$('.mega-menu').forEach(x=>x.hidden=true);$$('[data-submenu-toggle]').forEach(x=>x.setAttribute('aria-expanded','false'));panel.hidden=!on;button.setAttribute('aria-expanded',String(on))}));
document.addEventListener('click',e=>{if(!e.target.closest('.nav-group')){$$('.mega-menu').forEach(x=>x.hidden=true);$$('[data-submenu-toggle]').forEach(x=>x.setAttribute('aria-expanded','false'))}});document.addEventListener('keydown',e=>{if(e.key==='Escape'){$$('.mega-menu').forEach(x=>x.hidden=true);$$('[data-submenu-toggle]').forEach(x=>x.setAttribute('aria-expanded','false'))}});
const search=$('#header-search');if(search&&!search.value){const terms=[...document.querySelectorAll('[data-scent-term]')].map(el=>el.textContent.trim()).filter(Boolean);let i=0;if(terms.length&&!matchMedia('(prefers-reduced-motion: reduce)').matches)setInterval(()=>{if(document.hidden||document.activeElement===search||search.value)return;i=(i+1)%terms.length;search.placeholder='Ik zoek… '+terms[i]},3200)}

const favoriteKey = 'hzn-living-shopify-favorites-v1';

function readFav() {
  try {
    const items = JSON.parse(
      localStorage.getItem(favoriteKey) || '[]'
    );
    return Array.isArray(items)
      ? items.filter(x => typeof x === 'string')
      : [];
  } catch {
    return [];
  }
}

function paintFav() {
  const saved = readFav();
  const uniqueCount = new Set(saved).size;

  // A refined but always-visible counter, also on mobile.
  $$('[data-favorites-count]').forEach(node => {
    node.textContent = String(uniqueCount);
  });
  $$('[data-favorites-link]').forEach(link => {
    link.setAttribute('aria-label',
      'Favorieten: ' + uniqueCount + ' bewaarde ' + (uniqueCount === 1 ? 'favoriet' : 'favorieten'));
  });

  $$('[data-favorite]').forEach(button => {
    const active = saved.includes(button.dataset.favorite);

    button.classList.toggle('is-saved', active);
    button.setAttribute('aria-pressed', String(active));

    const label = $('[data-favorite-label]', button);
    if (label) {
      label.textContent = active
        ? 'Bewaard in favorieten'
        : button.dataset.favoriteSingle === 'true'
          ? 'Bewaar dit product'
          : 'Bewaar dit formaat';
    }
  });
}

document.addEventListener('click', event => {
  const button = event.target.closest('[data-favorite]');
  if (!button) return;

  event.preventDefault();

  const key = button.dataset.favorite;
  const saved = readFav();

  const next = saved.includes(key)
    ? saved.filter(x => x !== key)
    : [...saved, key];

  try {
    localStorage.setItem(favoriteKey, JSON.stringify(next));
  } catch {}

  paintFav();
  renderFavorites();
});

paintFav();

const favoritesList = $('[data-favorites-list]');
const favoritesEmpty = $('[data-favorites-empty]');

async function renderFavorites() {
  if (!favoritesList) return;

  const keys = readFav().slice(0, 50);
  favoritesList.replaceChildren();

  if (favoritesEmpty) {
    favoritesEmpty.hidden = keys.length > 0;
  }

  if (!keys.length) return;

  const root = window.Shopify?.routes?.root || '/';
  const currency = window.Shopify?.currency?.active || 'EUR';

  const money = amount =>
    new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency
    }).format(Number(amount) / 100);

  const cache = new Map();

  const getProduct = handle => {
    if (!cache.has(handle)) {
      cache.set(
        handle,
        fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
          .then(response => response.ok ? response.json() : null)
          .catch(() => null)
      );
    }
    return cache.get(handle);
  };

  const entries = await Promise.all(keys.map(async key => {
    const separator = key.lastIndexOf('::');

    const handle = separator === -1
      ? key
      : key.slice(0, separator);

    const variantId = separator === -1
      ? null
      : key.slice(separator + 2);

    const product = await getProduct(handle);
    if (!product) return null;

    const variant = variantId
      ? product.variants.find(v => String(v.id) === variantId)
      : null;

    if (variantId && !variant) return null;

    return { key, product, variant };
  }));

  entries.filter(Boolean).forEach(({ key, product, variant }) => {
    const card = document.createElement('article');
    card.className = 'product-card';

    const link = document.createElement('a');
    link.className = 'product-photo';

    link.href =
      root + 'products/' + encodeURIComponent(product.handle) +
      (variant
        ? '?variant=' + encodeURIComponent(String(variant.id))
        : '');

    const img = document.createElement('img');
    img.src = variant?.featured_image?.src
      || product.featured_image
      || '';

    img.alt = variant
      ? product.title + ' – ' + variant.title
      : product.title;

    img.loading = 'lazy';
    link.append(img);

    const info = document.createElement('div');
    info.className = 'product-info';

    // Products created before brand setup sometimes carry Shopify's
    // default supplier name. Never display 'Mijn winkel' as a brand.
    let brandName = (product.vendor || '').trim();
    if (!brandName || /^(mijn winkel|my store|hzn living)$/i.test(brandName)) {
      brandName = /^Baobab Collection\s*[-–—]/i.test(product.title)
        ? 'Baobab Collection'
        : '';
    }
    let displayTitle = product.title;
    if (brandName && displayTitle.toLowerCase().startsWith(brandName.toLowerCase())) {
      displayTitle = displayTitle.slice(brandName.length).replace(/^\s*[-–—]\s*/, '').trim();
    }
    const vendor = document.createElement('p');
    vendor.className = 'overline';
    vendor.textContent = brandName;

    const title = document.createElement('h3');
    const titleLink = document.createElement('a');

    titleLink.href = link.href;
    const hasVariantInTitle = variant && displayTitle.toLowerCase()
      .endsWith(variant.title.toLowerCase());
    titleLink.textContent = displayTitle +
      (variant && variant.title !== 'Default Title' && !hasVariantInTitle
        ? ' – ' + variant.title
        : '');

    title.append(titleLink);

    const price = document.createElement('p');
    price.textContent = money(
      variant ? variant.price : product.price
    );

    if (brandName) info.append(vendor);
    info.append(title, price);

    if (variant && !variant.available) {
      const soldOut = document.createElement('p');
      soldOut.className = 'sold-out';
      soldOut.textContent = 'Tijdelijk uitverkocht';
      info.append(soldOut);
    }

    const remove = document.createElement('button');
    remove.className = 'favorite-button is-saved';
    remove.type = 'button';
    remove.dataset.favorite = key;
    remove.setAttribute(
      'aria-label',
      'Verwijder uit favorieten'
    );
    remove.setAttribute('aria-pressed', 'true');
   
remove.innerHTML = `
  <svg class="icon icon-heart"
       viewBox="0 0 24 24"
       aria-hidden="true"
       focusable="false"
       fill="none"
       stroke="currentColor"
       stroke-width="1.5"
       stroke-linecap="round"
       stroke-linejoin="round">
    <path d="M20.4 4.8a5.4 5.4 0 0 0-7.6 0L12 5.6l-.8-.8a5.4 5.4 0 0 0-7.6 7.6L12 21l8.4-8.6a5.4 5.4 0 0 0 0-7.6Z"/>
  </svg>
`;


    card.append(remove, link, info);
    favoritesList.append(card);
  });

  if (favoritesEmpty) {
    favoritesEmpty.hidden = favoritesList.childElementCount > 0;
  }

  paintFav();
}

renderFavorites();

// Keep the counter, heart states and saved selection in sync across tabs.
window.addEventListener('storage', event => {
  if (event.key !== favoriteKey && event.key !== null) return;
  paintFav();
  renderFavorites();
});

const finder=$('[data-scent-finder]');if(finder){const questions=[{title:'Welke ruimte wil je verrijken?',options:[['woonkamer','Woonkamer'],['slaapkamer','Slaapkamer'],['badkamer','Badkamer'],['onderweg','Onderweg']]},{title:'Welk gevoel spreekt je aan?',options:[['warm','Warm en aards'],['fris','Fris en helder'],['bloemig','Zacht en bloemig'],['rijk','Rijk en kruidig']]},{title:'Hoe aanwezig mag de geur zijn?',options:[['subtiel','Subtiel'],['gebalanceerd','In balans'],['aanwezig','Aanwezig']]},{title:'Hoe wil je ervan genieten?',options:[['kaars','Geurkaars'],['diffuser','Diffuser'],['refill','Navulling'],['verrassing','Verras me']]}];let step=0,answers=[];function displayFinder(){finder.replaceChildren();if(step>=questions.length){const options=[...document.querySelectorAll('[data-scent-option]')];const keys={warm:'hout',fris:'fris',bloemig:'bloem',rijk:'kruid'};const mood=keys[answers[1]]||'';const chosen=options.find(el=>(el.dataset.family+' '+el.dataset.character).toLocaleLowerCase('nl').includes(mood))||options[0];const name=chosen?.dataset.name||'onze geuren';const label=document.createElement('p');label.className='eyebrow';label.textContent='JOUW GEURRICHTING';const heading=document.createElement('h2');heading.textContent=name;const copy=document.createElement('p');copy.textContent='Een eerste richting op basis van jouw antwoorden. Ontdek de producten en kies wat voor jou goed voelt.';const link=document.createElement('a');link.className='button';link.href=chosen?(window.Shopify?.routes?.root||'/')+'search?q='+encodeURIComponent(name)+'&type=product':'/collections/all';link.textContent='Ontdek '+name;const again=document.createElement('button');again.type='button';again.className='text-link';again.textContent='Begin opnieuw';again.addEventListener('click',()=>{step=0;answers=[];displayFinder()});finder.append(label,heading,copy,link,again);return}const count=document.createElement('p');count.className='eyebrow';count.textContent='VRAAG '+(step+1)+' / '+questions.length;const heading=document.createElement('h2');heading.textContent=questions[step].title;const options=document.createElement('div');options.className='finder-options';questions[step].options.forEach(([value,label])=>{const b=document.createElement('button');b.type='button';b.textContent=label+' ↗';b.addEventListener('click',()=>{answers[step]=value;step++;displayFinder()});options.append(b)});finder.append(count,heading,options);if(step){const back=document.createElement('button');back.type='button';back.className='text-link finder-back';back.textContent='← Vorige vraag';back.addEventListener('click',()=>{step--;displayFinder()});finder.append(back)}}displayFinder()}

const mainImage = $('#product-featured');

function showProductImage(imageUrl, imageAlt) {
  if (!mainImage || !imageUrl) return;

  // Voorkom dat de browser de oude afbeelding uit srcset kiest.
  mainImage.removeAttribute('srcset');
  mainImage.removeAttribute('sizes');

  mainImage.src = imageUrl;

  if (imageAlt) {
    mainImage.alt = imageAlt;
  }

  // Markeer automatisch de juiste miniatuur.
  $$('[data-gallery-image]').forEach(button => {
    const active = button.dataset.galleryImage === imageUrl;
    button.setAttribute('aria-pressed', String(active));
  });
}

function updateVariantGallery() {
  const select = $('[data-variant-select]');
  const gallery = $('[data-variant-gallery]');

  if (!select || !gallery) return;

  let visibleCount = 0;

  $$('[data-gallery-image]', gallery).forEach(button => {
    const belongsToVariant =
      button.dataset.galleryVariant === select.value;

    button.hidden = !belongsToVariant;

    if (belongsToVariant) {
      visibleCount++;
    } else {
      button.setAttribute('aria-pressed', 'false');
    }
  });

  // Verberg miniaturen als er maar één foto is.
  gallery.hidden = visibleCount <= 1;
}

// Handmatig wisselen tussen productfoto's.
$$('[data-gallery-image]').forEach(button => {
  button.addEventListener('click', () => {
    showProductImage(
      button.dataset.galleryImage,
      button.dataset.galleryAlt
    );
  });
});



const variant = $('[data-variant-select]');
const add = $('[data-product-add]');
const sticky = $('[data-mobile-purchase]');

function syncVariant() {
  if (!variant) return;
  const selected = variant.selectedOptions[0];
  if (!selected) return;

  const price = selected.dataset.price;
  const available = selected.dataset.available === 'true';

  // De zichtbare titel volgt alleen echte formaatopties, zonder de
  // Shopify-producttitel / canonical of JSON-LD te wijzigen.
  const heading = $('[data-product-heading]');
  if (heading) {
    const base = heading.dataset.headingBase || '';
    const suffix = (selected.dataset.headingSuffix || '').trim();
    const visibleTitle = suffix && suffix !== 'Default Title'
      ? base + ' ' + suffix
      : base;
    heading.textContent = visibleTitle;
    const stickyTitle = $('[data-sticky-title]');
    if (stickyTitle) stickyTitle.textContent = visibleTitle;
  }

  // Prijzen bijwerken
  $$('[data-product-price], [data-button-price], [data-sticky-price]')
    .forEach(el => {
      el.textContent = price;
    });

  const compare = $('[data-compare-price]');
  if (compare) {
    const comparePrice = selected.dataset.compare || '';
    compare.textContent = comparePrice;
    compare.hidden = !comparePrice;
  }

  // Winkelwagen blokkeren bij uitverkochte varianten
  if (add) {
    add.disabled = !available;

    const label = $('[data-product-add] .hzn-add-label');
    const buttonPrice = $('[data-button-price]', add);

    if (label) {
      label.textContent = available
        ? 'In winkelwagen'
        : 'Tijdelijk uitverkocht';
    }

    if (buttonPrice) buttonPrice.hidden = !available;
  }

  if (sticky) {
    const stickyButton = $('[data-sticky-add]', sticky);
    if (stickyButton) {
      stickyButton.disabled = !available;
      stickyButton.textContent = available
        ? 'In winkelwagen'
        : 'Uitverkocht';
    }
  }

  // Voorraadindicator inclusief rood bolletje
  const stock = $('[data-stock]');

  if (stock) {
    const count = Number(selected.dataset.stock);
    const lowStock =
      available &&
      selected.dataset.stock !== '' &&
      count > 0 &&
      count <= 3;

    const message = !available
      ? 'Tijdelijk uitverkocht'
      : lowStock
        ? 'Nog ' + count + ' op voorraad'
        : 'Op voorraad';

    const dot = document.createElement('i');
    if (lowStock) dot.className = 'amber-dot';

    stock.classList.toggle('is-out-of-stock', !available);
    stock.replaceChildren(dot, document.createTextNode(message));
  }

  // Bijbehorende afbeeldingen
  if (selected.dataset.image) {
    showProductImage(selected.dataset.image);
  }

  if (typeof updateVariantGallery === 'function') {
    updateVariantGallery();
  }

  // Bij uitverkochte maten wijzen we subtiel op een wél leverbaar formaat.
  // De alternatieve knop kiest een echte Shopify-variant; de gewone
  // winkelwagen-, prijs- en wishlistlogica blijft daardoor leidend.
  const alternative = $('[data-alternative-variant]');
  if (alternative) {
    alternative.hidden = true;
    alternative.onclick = null;
    if (!available) {
      const options = [...variant.options];
      const currentIndex = options.findIndex(option => option.value === selected.value);
      const nearest = options
        .map((option, index) => ({ option, index }))
        .filter(({ option }) => option.dataset.available === 'true')
        .sort((a, b) =>
          Math.abs(a.index - currentIndex) - Math.abs(b.index - currentIndex) ||
          a.index - b.index
        )[0];
      if (nearest) {
        const name = nearest.option.textContent.trim();
        alternative.textContent = 'Bekijk beschikbaar formaat: ' + name + ' →';
        alternative.hidden = false;
        alternative.onclick = () => {
          const control = $$('[data-variant-button]')
            .find(button => button.dataset.variantId === nearest.option.value);
          if (control) control.click();
          else {
            variant.value = nearest.option.value;
            variant.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };
      }
    }
  }

  // Hartje koppelen aan het gekozen formaat
  const favorite = $('[data-favorite-variant-button]');

  if (favorite) {
    favorite.dataset.favorite =
      favorite.dataset.favoriteHandle + '::' + selected.value;

    const variantTitle = selected.textContent
      .trim()
      .replace(/\s*·\s*uitverkocht\s*$/i, '');

    favorite.setAttribute(
      'aria-label',
      'Bewaar ' + variantTitle + ' als favoriet'
    );

    paintFav();
  }
}

if (variant) {
  variant.addEventListener('change', () => {
    syncVariant();
    // Deelbare variantlink voor Merchant Center en klanten. UTM's en
    // andere bestaande queryparameters blijven behouden; canonical blijft basis-URL.
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.value);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (_) { /* De variantkeuze blijft werken als URL-aanpassing niet lukt. */ }
  });
  syncVariant();

  // Extra bescherming tegen bestellen zonder voorraad
  const productForm = $('[data-product-form]');

  if (productForm) {
    productForm.addEventListener('submit', event => {
      const selected = variant.selectedOptions[0];

      if (selected?.dataset.available !== 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }
}


function syncSticky(){if(!sticky||!add)return;sticky.hidden=!(window.matchMedia('(max-width: 760px)').matches&&add.getBoundingClientRect().bottom<0)}if(sticky){window.addEventListener('scroll',syncSticky,{passive:true});window.addEventListener('resize',syncSticky);$('[data-sticky-add]',sticky).addEventListener('click',()=>{const form=$('.product-form');if(form?.requestSubmit)form.requestSubmit(add);else add.click()});syncSticky()}
const undoKey='hzn-cart-undo';const cartUndo=$('[data-cart-undo]');if(cartUndo){let pending=null;try{pending=JSON.parse(sessionStorage.getItem(undoKey)||'null')}catch{}if(pending&&Date.now()-pending.time<9000){cartUndo.hidden=false;setTimeout(()=>{cartUndo.hidden=true;sessionStorage.removeItem(undoKey)},9000-(Date.now()-pending.time))}$$('[data-remove-line]').forEach(b=>b.addEventListener('click',async()=>{b.disabled=true;const item={id:b.dataset.variantId,quantity:Number(b.dataset.quantity),time:Date.now()};try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:Number(b.dataset.removeLine),quantity:0})});if(!response.ok)throw Error('Kon product niet verwijderen');sessionStorage.setItem(undoKey,JSON.stringify(item));location.reload()}catch{b.disabled=false;alert('Verwijderen lukte niet. Probeer het opnieuw.')}}));$('[data-undo-remove]',cartUndo)?.addEventListener('click',async()=>{let item;try{item=JSON.parse(sessionStorage.getItem(undoKey)||'null')}catch{}if(!item)return;try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.id,quantity:item.quantity})});if(!response.ok)throw Error('Kon product niet herstellen');sessionStorage.removeItem(undoKey);location.reload()}catch{alert('Terugzetten lukte niet. Voeg het product opnieuw toe.')}})}
})();